import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { Icons } from '@shared/ui';
import i18n from '@shared/i18n';
import { useNavigationContext } from './useNavigation';
import { MenuItem } from './MenuItem';

interface MenuMobileGroupProps {}

export const MenuMobileGroup: React.FC<MenuMobileGroupProps> = () => {
    const { state, actions } = useNavigationContext();

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <>
            <div
                role="button"
                tabIndex={0}
                className="menu-backdrop"
                onClick={actions.handleMenuStatusReset}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        actions.handleMenuStatusReset();
                    }
                }}
            />
            <div
                className={clsx('menu-list', 'menu-list--responsive', {
                    'menu-list--responsive-open': state.isMobileMenuOpen,
                })}
            >
                <div className="menu-item">
                    <button
                        className="menu-hamburger"
                        onClick={actions.handleMenuStatusReset}
                        aria-label="Close Menu"
                    >
                        <Icons.csr.X size="24px" weight="bold" />
                    </button>
                </div>
                <div className="menu-mobile-content">
                    <ul className="menu-ul">
                        {!!state.currentNode.length && (
                            <li className="menu-item">
                                <button
                                    type="button"
                                    className="menu-mobile-back"
                                    onClick={actions.handleMenuBack}
                                >
                                    <Icons.csr.CaretLeft size="20px" weight="bold" />
                                    <span>{i18n.gettext('返回')}</span>
                                </button>
                            </li>
                        )}
                        <div className="menu-mobile-divider" />
                        {(
                            state.navigationGroup[state.currentNodeLevel] ||
                            state.navigation?.next ||
                            []
                        ).map((item, index) => (
                            <MenuItem
                                key={`${item.value}-${item.name}-${index}`}
                                {...item}
                                showOpenInNewTab={state.openInNewTab}
                                levelIndex={state.currentNode.length}
                            >
                                {item.name}
                            </MenuItem>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};
